/*
 * ct-new-badge.js | Cosmetique Totale
 * 'Nieuw'-badge op de USF-collectie- en zoekpagina's (Ultimate Search &
 * Filter tekent die kaarten zelf, niet via snippets/product-grid-item.liquid).
 * Zelfde regel en opmaak als snippets/ct-new-badge.liquid: tag 'nieuw'
 * (hoofdletters maken niet uit, 'new' telt niet).
 *
 * Werkt via de officiële USF-plug-inhaak 'searchResultsProductWishList': die
 * staat in de kaart-template direct in .grid-product__image-wrap (niet in
 * het labelblok linksboven), assets/usf-custom.js. Wordt verder niet
 * gebruikt (geen wishlist-app). De badge staat rechtsonder op de foto (CSS).
 * USF roept plug-ins bij elke weergave aan (usf.plugins.invoke), dus het
 * maakt niet uit dat dit bestand later registreert dan usf.js laadt.
 * Op pagina's zonder USF stopt het wachten vanzelf na ~10 seconden.
 * Geladen in snippets/preload-js.liquid (bewust niet in snippets/usf.liquid:
 * dat bestand overschrijft de USF-app bij een theme-sync).
 * Stijl: assets/overrides.css, blok "Nieuw-badge".
 */
(function () {
  var LABELS = { nl: 'Nieuw', de: 'Neu', fr: 'Nouveau', en: 'New' };

  function label() {
    var lang = String(window._usfLocale || (window.Shopify && window.Shopify.locale) || 'nl').slice(0, 2).toLowerCase();
    return LABELS[lang] || LABELS.nl;
  }

  function isNew(product) {
    var tags = product && product.tags;
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).trim().toLowerCase() === 'nieuw') return true;
    }
    return false;
  }

  var plugin = {
    render_searchResultsProductWishList: function (parent, h, data) {
      if (!isNew(data && data.product)) return null;
      return h('span', { class: 'ct-new-badge ct-new-badge--grid' }, label());
    }
  };

  var tries = 0;
  (function register() {
    if (window.usf && window.usf.plugins && typeof window.usf.plugins.push === 'function') {
      window.usf.plugins.push(plugin);
      return;
    }
    if (tries++ < 400) setTimeout(register, 25);
  })();
})();
